import {createSlice, PayloadAction} from '@reduxjs/toolkit'

export interface UserState {
    personId: number
    firstName: string
    lastName: string,
    email: string,
    keycloakUuid?: string,
}

const userInitialState: UserState = {
    personId: -1,
    firstName: '',
    lastName: '',
    email: '',
    keycloakUuid: ''
}

const userSlice = createSlice({
    name: 'user',
    initialState: userInitialState,
    reducers: {
        setUser(state, action: PayloadAction<UserState>) {
            state.personId = action.payload.personId
            state.firstName =  action.payload.firstName
            state.lastName =  action.payload.lastName
            state.email = action.payload.email
            state.keycloakUuid = action.payload.keycloakUuid
        }
    }
})

export const { setUser } = userSlice.actions
export default userSlice.reducer
